import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import {sections} from '../../../utils/variables'
import './menu.css'
import Login from '../../Login/Container'
class AdminMenu extends Component {


    
    componentDidMount(){

    }

    
    render() {


	return (

	    <div style={{backgroundColor: '#db4c4c'}}>
		{ this.props.authenticated ?
		  <div style={{padding: '10px'}}>
		      
		      <b>Povezave za administracijo</b>: <Link to="/events"><button className="btn btn-brown">Novice in dogodki</button></Link>&nbsp;
		  <Link  to="/pages"><button className="btn btn-brown">Strani</button></Link>&nbsp;
		  <Link  to="/albums"><button className="btn btn-brown">Albumi</button></Link>&nbsp;
		  <Link  to="/podcasts"><button className="btn btn-brown">Podcast</button></Link>&nbsp;
		  <Link  to="/live"><button className="btn btn-brown">Live</button></Link>
		  <button style={{float: 'right'}} onClick={this.props.logout} className="btn btn-brown">Log Out</button></div>
		  
		  :
		  ''}
		
	    </div>
	);
    }
}

export default AdminMenu;



// WEBPACK FOOTER //
// ./src/components/Layout/AdminMenu/index.jsx